import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from './close.svg';
import {Image} from '../../Image';

const ENTER_KEY_CODE = 13;
const SPACE_KEY_CODE = 32;
const CLOSE_ICON_STYLE = {
  display: 'inline-block',
  top: '3px',
  position: 'relative',
};

/**
 * The close button to be displayed with Modal Window
 */
export function CloseButton(props) {
  const keyDown = (event) => {
    if (event.keyCode === ENTER_KEY_CODE || event.keyCode === SPACE_KEY_CODE) {
      props.close(event);
    }
  };
  return (
    <div className='closeButton-block'>
      <span className={props.size} onKeyDown={keyDown} onClick={props.close}>
        Close
        <Image
          style={CLOSE_ICON_STYLE}
          src={CloseIcon}
          aria-label='Close button'
          alt='Close button'
        />
      </span>
    </div>
  );
}

CloseButton.propTypes = {
  /**
   * callback function to be involked close button is clicked
   */
  close: PropTypes.func,
  /**
   * String value to specify the size of modal
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

CloseButton.defaultProps = {
  size: 'sm',
};
